import { selectV1Websocket, selectV1WebsocketStatus } from '../selectors/v1Session';
import type { WebsocketStatus } from '../store/slices/v1Session';
import { useAppSelector } from '../store/store';

export const useV1Socket: () => [WebSocket | undefined, WebsocketStatus] = () => {
  const v1Socket = useAppSelector(selectV1Websocket);
  const v1SocketStatus = useAppSelector(selectV1WebsocketStatus);

  // Return an object instead... It makes more sense to destructure the correct property name instead of
  // destructuring array members
  return [v1Socket, v1SocketStatus];
};
